// DS: i3.45
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const BoostFilled: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          fillRule="evenodd"
          d="M20.204 2.507a1.173 1.173 0 011.29 1.291l-.606 5.92a1.18 1.18 0 01-.337.713l-4.892 4.924-.968 3.19a1.177 1.177 0 01-.45.623l-3.031 2.12c-.524.367-1.105.2-1.426-.066a1.208 1.208 0 01-.37-1.341c.678-1.878.285-3.638-.65-4.37-1.279-.998-2.86-1.103-4.806-.637-1.005.24-1.88-.898-1.24-1.824L4.94 9.827a1.17 1.17 0 01.629-.458l3.203-.954 4.899-4.93c.188-.19.435-.31.7-.339l5.833-.639zm-3.065 5.854c0 .813-.655 1.471-1.462 1.471a1.467 1.467 0 01-1.462-1.471c0-.813.655-1.472 1.462-1.472.807 0 1.462.66 1.462 1.472zM3.083 20.966c-.083.172.096.352.266.269l4.224-2.065a.201.201 0 00.054-.322L5.454 16.66a.199.199 0 00-.32.054l-2.051 4.253z"
          clipRule="evenodd"
        ></path>
      </svg>
    </IconWrap>
  );
};
BoostFilled.displayName = 'BoostFilled';

export default BoostFilled;
